<template>
  <base-wrapper class="space-y-4">
    <base-card title="Tambah Saldo Saldo Sisa Pembayaran SC">
      <form class="grid gap-4 sm:grid-cols-3" @submit.prevent="onSubmit">
        <div class="sm:col-span-3">
          <base-input inset with-label label="Tanggal" disabled :value="date" />
        </div>
        <div>
          <search-office-input with-stockist-center-balance v-model="office" />
        </div>
        <div>
          <base-input
            inset
            with-label
            label="Nama Stockist Center"
            placeholder="SC1"
            disabled
            :value="office.name"
          />
        </div>
        <div>
          <base-input
            inset
            with-label
            label="Saldo Sisa Pembayaran"
            placeholder="0"
            disabled
            :value="office.overpayment_balance | toCurrency"
          />
        </div>
        <div class="sm:col-span-3">
          <base-input
            inset
            with-label
            label="Nominal Topup"
            placeholder="100.000"
            type="text"
            currency
            v-model="amount"
          />
        </div>
        <div class="flex items-center gap-2 sm:col-span-3">
          <base-button :disabled="disabled">Simpan</base-button>
          <base-button
            type="button"
            color="white"
            :to="{ name: 'kasir.tarik.saldo-sisa-pembayaran-sc' }"
            >Kembali</base-button
          >
        </div>
      </form>

      <loading v-if="loading" />
    </base-card>
  </base-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import SearchOfficeInput from '@/components/office/search-office-input.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { SearchOfficeInput },
  mixins: [requestMixin],
  data() {
    return {
      amount: null,
      date: dayjs().format('YYYY-MM-DD'),
      office: {
        id: null,
        code: null,
        originalCode: null,
        name: null,
        overpayment_balance: null,
      },
      loading: false,
    };
  },
  computed: {
    disabled() {
      if (
        !this.office.id ||
        !this.amount ||
        this.office.overpayment_balance < 1
      ) {
        return true;
      }

      return (
        Number(this.amount.replace(/\D/gi, '')) >
        this.office.overpayment_balance
      );
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onSubmit() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/offices/${this.office.id}/-actions/with-draw-sc`,
        {
          method: 'post',
          data: {
            trx_type: 'overpayment_balance',
            amount: Number(this.amount.replace(/\D/gi, '')),
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.$router.push({ name: 'kasir.tarik.saldo-sisa-pembayaran-sc' });
      }

      this.loading = false;
    },
  },
};
</script>
